/**
 * UZUN PAUZA EKRAN YERİ TUTMUR — veb TV-nin hər iki skini (cihaz + brauzer) üçün hədd.
 *
 * 2026-10-25, sahib qərarı 19 («bütün platformalarda bir pauza qaydası — iPhone/tvOS qaydası»).
 * Kod oxunuşunda tapıldı: heartbeat (`lib/playback.ts → handleFor`) videonun vəziyyətinə baxmır.
 * ƏVVƏL pauzada unudulmuş film hər 60 saniyədə heartbeat göndərirdi — sessiya saatlarla planın ekran
 * sayında qalırdı və ailənin başqa üzvü «ekran sayı doldu» alırdı. Pauza səhifəni gizlətmir, yəni
 * `visibilitychange` gəlmir (televizorun ekran qoruyucusunun onu verib-vermədiyi ölçülməyib). İndi pauza bu qədər fasiləsiz davam edəndə mövqe
 * yazılır və sessiya bitirilir (`screens/player.ts → releaseForLongPause`); «oynat» səhifə
 * gizlənməsindən sonrakı eyni yolla (`resumeSession` → `/sessions`) təzə sessiya açır.
 *
 * NİYƏ 5 DƏQİQƏ: iOS-un seçdiyi dəyərdir (`KinoboxPlayer.swift` → `pausedSessionGrace`) — iOS-un
 * «Avto-kilid» seçimlərinin ən uzunu («Heç vaxt»dan başqa) 5 dəqiqədir. Qısa pauzalar heç nə
 * dəyişmir: hər bitirmə qayıdışda yeni iddia deməkdir, iddia isə başqa cihazı sıxışdıra bilər.
 * Server heartbeat-siz sessiyanı 180 saniyədə sayımdan çıxarır; 5 dəqiqə onun ~1,7 mislidir.
 *
 * ⚠ AYRICA MODULDADIR, `lib/playback.ts`-də DEYİL: oynadıcı testləri `lib/playback`-i bütövlükdə
 *   saxtalaşdırır — sabit orada olsaydı testdə `undefined` olar, taymer dərhal işə düşərdi.
 * ⚠ PiP üçün iPhone-dakı 60 saniyə burada YOXDUR: veb TV oynadıcısında PiP düyməsi yoxdur.
 */
export const PAUSED_SESSION_RELEASE_MS = 5 * 60 * 1000
